if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const allowGiftProps = this.dataset.showGiftItem === "true";
        const sectionId = this.dataset.sectionId;
        const container = sectionId
          ? document.getElementById(`MainProduct-${sectionId}`)
          : document;
        const freeInputs = allowGiftProps
          ? container.querySelectorAll('input[data-item="free"]:checked')
          : [];
        if (allowGiftProps && freeInputs.length > 0) {
          freeInputs.forEach((input, index) => {
            let title = input.getAttribute('data-title');
            if (!title) {
               const row = input.closest('.free-product-item-row');
               const titleEl = row ? row.querySelector('.item-title h4') : null;
               title = titleEl ? titleEl.innerText.trim() : `Free Gift ${index + 1}`;
            }
            // Append as readable property
            formData.append(`properties[Free Gift ${index + 1}]`, title);
            // Append internal ID if needed (hidden by default theme logic usually)
            formData.append(`properties[_FreeGiftVariantId ${index + 1}]`, input.value);
          });
        }
        const selectedUpsellVariantIds = [];
        const upsellItems = container.querySelectorAll(".upsell-product-item");
        upsellItems.forEach((item) => {
          const checkbox = item.querySelector('input[data-item="upsell"]');
          if (!checkbox || !checkbox.checked) return;

          const variantSelect = item.querySelector(".upsell-variant-select");
          const selectedVariantId = variantSelect ? variantSelect.value : checkbox.value;
          const parsedVariantId = parseInt(selectedVariantId, 10);
          if (!Number.isNaN(parsedVariantId)) {
            selectedUpsellVariantIds.push(parsedVariantId);
          }
        });
        const mainVariantId = formData.get("id");
        const mainQuantity = parseInt(formData.get("quantity") || "1", 10);
        const serializedProps = {};
        for (const [key, value] of formData.entries()) {
          if (key.startsWith("properties[")) {
            const propKey = key.slice(11, -1);
            serializedProps[propKey] = value;
          }
        }

        const hasUpsellItems = selectedUpsellVariantIds.length > 0;
        if (hasUpsellItems) {
          const items = [];

          selectedUpsellVariantIds.forEach((upsellVariantId) => {
            items.push({
              id: upsellVariantId,
              quantity: 1,
            });
          });

          const mainItem = {
            id: Number(mainVariantId),
            quantity: Number.isNaN(mainQuantity) || mainQuantity < 1 ? 1 : mainQuantity,
          };
          if (Object.keys(serializedProps).length > 0) {
            mainItem.properties = serializedProps;
          }
          items.push(mainItem);

          config.headers["Content-Type"] = "application/json";
          config.body = JSON.stringify({
            items,
            sections: this.cart
              ? this.cart.getSectionsToRender().map((section) => section.id).join(",")
              : undefined,
            sections_url: window.location.pathname,
          });
        } else {
          config.body = formData;
        }
        
        // Always use the standard single-item fetch which handles sections and cart drawer properly
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.items && response.items.length > 0) {
              const mainItemResp = response.items.find(item => item.variant_id === Number(mainVariantId)) || response.items[response.items.length - 1];
              response.key = mainItemResp.key;
              response.id = mainItemResp.id;
              response.product_id = mainItemResp.product_id;
              response.variant_id = mainItemResp.variant_id;
            }

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error)
              this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
